'use strict';

module.exports = [// types
require('./Matrix'), require('./DenseMatrix'), require('./SparseMatrix'), require('./Spa'), require('./FibonacciHeap'), require('./ImmutableDenseMatrix'), require('./MatrixIndex'), require('./Range'), // construction functions
require('./function/index'), require('./function/matrix'), require('./function/sparse'), // util functions
require('./utils/getArrayDataType')];


//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/type/matrix/index.js
// module id = 3ycz
// module chunks = 0